export default function TopicsSection() {
  const topics = [
    { label: '暑期档', hot: true },
    { label: '高分神作', hot: true },
    { label: '国产剧', hot: true },
    { label: '韩剧推荐', hot: false },
    { label: '好莱坞大片', hot: true },
    { label: '悬疑推理', hot: false },
    { label: '动漫新番', hot: false },
    { label: '经典港片', hot: false },
    { label: '纪录片精选', hot: false },
  ];

  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            当前最受关注的影视热点，点击探索你感兴趣的内容
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {topics.map((topic, i) => (
              <a
                key={i}
                href="#index"
                className={`group inline-flex items-center gap-2 px-5 py-2.5 rounded-full border transition-all duration-300 cursor-pointer whitespace-nowrap text-sm ${
                  topic.hot
                    ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100 hover:border-primary-300'
                    : 'bg-background-50 border-background-200 text-foreground-600 hover:bg-background-200 hover:border-background-300'
                }`}
              >
                {topic.label}
                {topic.hot && (
                  <span className="flex-shrink-0">
                    <i className="ri-fire-line text-accent-500 text-xs"></i>
                  </span>
                )}
              </a>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-4 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-fire-line text-accent-500"></i>
              标记为当前热门话题
            </span>
            <span>话题基于近期用户浏览数据统计</span>
            <span>每周一更新话题热度</span>
          </div>
        </div>
      </div>
    </section>
  );
}